<template>
  <a
    :aria-label="$t('search.navigate-to', { label })"
    class="cursor-pointer flex justify-start items-start py-2 xl:px-2 transition"
    :class="{
      'bg-blue-100 text-indigo-700': !isRefresh && isActive,
      'bg-grimace-100 font-medium text-sm text-black': isRefresh && isActive,
      'text-neutral-700 hover:text-neutral-600': isRefresh && !isActive,
      'hover:text-indigo-600': !isRefresh,
      'font-medium': isRefresh,
      'rounded-md': !fullBackground,
      'px-3 bg-grimace-50': isEmbedded,
      'px-6': !isEmbedded,
    }"
    :href="href"
    @click.prevent="$emit('click', navId)"
    @keydown.prevent="$emit('click', navId)"
  >
    <span class="h-4 w-4 mr-4">
      <fa
        v-if="icon"
        :icon="[isActive ? 'fas' : 'fal', icon]"
        class="mt-0.5 fa-fw"
        :class="{
          'text-neutral-950': isRefresh && isActive,
          'text-neutral-700': isRefresh && !isActive,
          'text-indigo-600': !isRefresh,
          'mr-5': isEmbedded,
        }"
      />
    </span>
    <span class="font-medium text-sm">{{ label }}</span>
  </a>
</template>

<script>
export default {
  name: 'VetsterSideNavLink',

  props: {
    activeNav: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    href: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    navId: {
      type: String,
      default: null,
    },
    fullBackground: {
      type: Boolean,
      default: false,
    },
    isEmbedded: {
      type: Boolean,
      default: false,
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],

  computed: {
    isActive() {
      return this.activeNav === `#${this.navId}`;
    },
  },
};
</script>
